/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "돌아가기",
      "<h3 class=”header-3”>접근성 현황</h3> <p>유럽 접근성법(European Accessibility Act)에 따라 당사는 접근성을 고려하여 전자상거래 서비스(신원 확인 및 결제 방식 포함)를 설계할 의무가 있습니다. 이를 통해 서비스가 인지 가능하고, 조작 가능하며, 이해 가능하고, 기술적으로 견고하게 작동하도록 하고 있습니다. 또한 당사는 웹사이트와 모바일 애플리케이션을 <a href=\"https://www.w3.org/WAI/standards-guidelines/wcag/\" target=\"_blank\">W3C의 웹 콘텐츠 접근성 지침(WCAG) 2.1 Level AA</a>에 부합하도록 설계하기 위해 노력하고 있습니다. 이를 위해 다음과 같은 활동을 진행하고 있습니다.</p> <ul> <li>Level Access와 같은 접근성 전문 컨설팅 기관과 협력하여 서비스 접근성을 개선할 수 있는 방안을 검토하고 있습니다.</li> <li>당사의 디지털 경험을 글로벌 접근성 기준에 따라 평가하고 있습니다.</li> <li>장애가 있는 사용자와 추가적인 접근성 지원이 필요한 사용자를 포함한 다양한 접근성 전문가들의 인사이트를 얻고 있습니다.</li> </ul>",
      "<h3 class=”header-3”>피드백 및 문의</h3> <p>당사는 모든 사용자가 서비스를 이용하는 데 불편함이 없도록 접근성을 확보하기 위해 노력하고 있습니다. 다만 일부 제한이 있을 수 있습니다. 서비스 이용 중 접근성 관련 문제를 발견하시거나 다른 형식의 정보 제공이 필요하신 경우, 개선에 도움이 될 수 있도록 의견을 보내주시기 바랍니다. 아래 이메일로 문의해 주세요: accessibility@bumble.com.</p>",
      "<h3 class=”header-3”>향후 개선 계획</h3> <p>접근성 개선을 위한 당사의 노력은 계속되고 있습니다. 앞으로도 다음과 같은 활동을 지속할 예정입니다.</p> <ul> <li>모든 디지털 플랫폼에서 접근성 상태를 지속적으로 모니터링하고 점검합니다.</li>\n<li>확인된 문제를 해결하고, 접근성을 고려한 설계를 통해 향후 발생할 수 있는 접근성 문제를 예방합니다.</li> <li>포용적 디자인 관행을 강화하기 위해 내부 교육과 인식 제고 활동을 확대합니다.</li> </ul>",
      "<h3 class=”header-3”>최종 업데이트: 2025년 11월</h3>",
      "<h3 class=”header-3”>접근성 향상을 위한 조치</h3> <p>당사 서비스의 접근성을 확보하기 위해 다음과 같은 조치를 시행하고 있습니다.</p> <ul><li>Level Access와 협력하여 포괄적인 접근성 평가를 수행하고 개선을 위한 자문을 받고 있습니다.</li> <li>키보드 대체 기능, 음성 지원, 터치 없이 이용할 수 있는 내비게이션 등 보조 기술을 포함한 접근성 도구를 플랫폼에 적용하고 있습니다.</li> <li>장애가 있는 사용자를 대상으로 사용자 테스트를 진행하여 실제 사용자 피드백을 수집하고 서비스 개선에 반영하고 있습니다.</li> <li>제품 개발 라이프사이클과 품질 보증(QA) 프로세스 전반에 접근성 요소를 통합하고 있습니다.</li> <li>조직 전반에 걸쳐 디지털 접근성 프로그램을 운영하고 있습니다.</li> <li><a href=\"https://www.levelaccess.com/bumble/\" target=\"_blank\">접근성 지원 고객 경험 플랫폼</a>을 도입했습니다. 이 플랫폼은 타이핑, 제스처 사용, 마우스 조작 또는 읽기에 어려움이 있는 사용자가 무료로 이용할 수 있습니다. 마우스 및 키보드 대체 기능, 음성 인식, 음성 지원, 핸즈프리 또는 터치프리 내비게이션 등 다양한 도구를 포함하고 있습니다.</li> </ul>",
      "<h3 class=”header-3”>우리의 정책</h3> <p>Bumble에서는 공정성과 포용성을 핵심 가치로 삼고 있습니다. 이는 단순한 유행어가 아니라, Bumble을 사용하는 모든 사람이 접근성을 갖춘 공정하고 형평성 있는 경험을 할 수 있도록 노력한다는 의미입니다.</p> <p>이 접근성 성명서는 당사 서비스의 접근성과 관련 법적 및 기술적 기준과의 정합성에 대해 사용자에게 안내하기 위해 작성되었습니다. 본 접근성 성명서는 유럽 접근성법(European Accessibility Act)의 적용을 받는 Bumble 서비스 요소[RS2]에 적용되며, 특히 사용자가 Bumble의 향상된 프리미엄 기능으로 업그레이드할 수 있는 전자상거래 서비스를 포함합니다. 이러한 서비스는 Bumble 앱을 통해 이용할 수 있습니다.</p>",
      "EAA 접근성 성명서",
      "App Store에서 다운받기",
      "Google Play에서 다운받기",
      "캐러셀",
      "슬라이드 {{number}}",
      "다음 슬라이드",
      "이전 슬라이드",
      "슬라이드",
      "슬라이드 {{total}} 중 {{number}}",
      "내 개인정보를 판매하거나 공유하지 않음",
      "내 개인정보를 판매하거나 공유하지 않음",
      "Bumble 에서 상대방의 프로필의 어떤 점이 마음에 드는지 알려주기위해 칭찬보내기를 사용해보세요. 짝이 되기 전에 상대방의 주목을 끌 수 있어요. 지금 사용해보세요",
      "칭찬 보내기 | 칭찬 보내기를 사용하는 방법 | Bumble",
      "하루에 한 번씩 업데이트되는 맞춤형 페이지, 회원님과 가장 잘 맞을 것 같은 사람들을 하이라이트합니다.",
      "발견 | 나랑 잘 맞는 사람들 찾기 | Bumble",
      "스스로의 속도에 따라 데이트를 즐기고 투명 회원 모드로 회원님의 Bumble 프로필을 볼 수 있는 사람들을 관리하세요. 저희의 가이드에서 Bumble 투명 회원 모드를 사용하는 방법에 대해서 알아보세요",
      "투명 회원 모드 | 회원님의 프로필을 숨기세요 | Bumble",
      "Bumble 의 IRL 이벤트에서 만난 후, 앱에서 대화를 이어가며 관계를 발전시키세요.",
      "바로 짝되기 | 앱에서 대화를 계속 이어가세요 | Bumble",
      "휴식이 필요하거나 스스로를 위한 시간이 필요하세요? Bumble 의 스누즈 모드를 통해 회원님의 Bumble 계정을 일시 정지하는 방법을 알아보세요. 내가 원하는 속도로 데이트할 수 있어요",
      "스누즈 모드 | 회원님의 계정을 일시정지하세요 | Bumble",
      "Bumble 에서 마음에 드는 사람을 보셨다구요? SuperSwipe로 진심을 표현하고 상대방의 눈길을 끌어보세요. 상대방 프로필의 별을 탭하거나, 여기에서 자세한 정보를 확인하세요",
      "Bumble SuperSwipe | SuperSwipe가 무엇인가요? | Bumble",
      "출장 또는 휴가를 위해 여행하십니까? Bumble 의 여행 모드를 통해 새로운 장소에서 재미있는 새로운 연결을 만들 수 있습니다. 여행 모드를 여기에서 지금 바로 확인해보세요",
      "Bumble 의 여행 모드 | 어디서든 데이트를 찾으세요 | Bumble",
      "메시지로 느끼는 분위기가 실제로 만났을 때도 같을지 알고 싶으세요? Bumble 에서 이제 영상 채팅이나 음성 통화를 시도해서 좋은 분위기를 확인해보세요",
      "영상 채팅 | 전화를 시작하세요 | Bumble",
      "Bumble Date",
      "당사 앱들",
      "소개",
      "인재채용",
      "문의하기",
      "투자자",
      "상점",
      "회사소개",
      "앱 다운로드하기",
      "Bumble 에서의 접근성",
      "가이드라인",
      "쿠키 관리",
      "현대 노예제 방지법",
      "수집 시 통지",
      "개인정보 취급방침",
      "이용약관",
      "법무",
      "Washington 소비자 건강 개인정보 취급방침",
      "QR 코드를 스캔해서 Bumble 앱을 다운로드하세요",
      "로그인하기",
      "이곳에서 계약을 종료하세요",
      "지금 다운로드하기",
      "QR 코드를 스캔하여 시작하세요.",
      "다음 데이트 상대를 찾아보세요",
      "앱을 다운로드하세요",
      "Bumble 홈페이지",
      "메뉴 닫기",
      "메뉴 열기",
      "곧 출시: Bumble 연애 이야기",
      "회원님의 언어를 선택하세요",
      "언어 옵션",
      "꼬리말",
      "Bumble 에서의 접근성",
      "Apple 및 Apple 로고는 Apple Inc.의 등록 상표입니다.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "인재채용",
      "이벤트",
      "Google Play는 Google LLC의 상표입니다.",
      "가이드라인",
      "투자자",
      "쿠키 관리",
      "쿠키 관리",
      "현대판 노예 방지 성명",
      "수집 시 통지",
      "개인정보 취급방침",
      "시즌 별 데이트 가이드",
      "이용약관",
      "앱",
      "Washington 소비자 건강 데이터 개인 정보 보호 정책",
      "소개",
      "앰배서더",
      "커뮤니티를 찾고 새로운 친구를 만드세요",
      "전문적으로 네트워크를 구축하고 경력을 쌓으세요",
      "진지한 관계, 캐주얼한 관계 또는 그 사이에 있는 것을 찾으세요",
      "The Buzz",
      "더 알아보기",
      "트래블 모드로{{__EOL__}}전세계와 연결되세요",
      "데이트",
      "이벤트",
      "기능들",
      "Compliments™",
      "Compliments를 보내서 사람들 속에서 돋보이세요.",
      "발견",
      "하루에 한 번씩 업데이트되는 맞춤형 페이지, 회원님과 가장 잘 맞을 것 같은 사람들을 하이라이트합니다.",
      "투명 회원 모드",
      "투명 회원 모드를 사용해서 전 연인, 친척, 직장 상사로부터 프로필을 숨기세요.",
      "바로 짝되기",
      "Bumble IRL 이벤트에서 대화를 시작하셨나요? 앱에서 계속 이어가세요.",
      "스누즈 모드",
      "스누즈 모드로 데이팅을 일시정지하세요. 다시 데이트할 준비가 되면, 언제든지 돌아오세요.",
      "SuperSwipe",
      "상대방의 프로필 분위기가 합격이라구요? SuperSwipe로 마음을 전하세요.",
      "트래블 모드",
      "트래블 모드로 전 세계 어느 곳에서 짝이 될 수 있어요.",
      "영상 채팅",
      "영상 채팅과 음성 통화를 사용해서 실제로 만날 준비가 됐는지 확인해보세요.",
      "Bumble 앱을 다운로드하세요",
      "BFF",
      "안전",
      "스토리",
      "지원",
      "상점",
      "메인",
      "Compliments를 보내서 많은 사람들 속에서 기억에 남는 사람이 되세요.",
      "Compliments",
      "진솔하고 서로 존중하는 의미 있는 연결을 만들기 위해 설계된 기능입니다.",
      "전 연인, 친척, 직장 상사로부터 프로필을 숨기세요.",
      "투명 회원 모드",
      "스누즈 모드로 데이팅을 일시정지하세요.",
      "스누즈 모드",
      "마음에 드는 사람을 보셨나요? 상대방에게 알려주세요.",
      "SuperSwipe",
      "데이트 탐색하기",
      "최애 면세점 과자와 짝을 전세계에서 어디서나 찾아보세요.",
      "트래블 모드",
      "굳이 외출할 필요 없이 오프라인 만남과 비슷한 경험을 쌓으세요.",
      "영상 통화",
      "Bumble 경험을 브라우저에서 바로 즐기세요.",
      "웹 앱",
      "우리의 리더들은 Bumble 의 가치를 국가 곳곳에 있는 커뮤니티에 도입하는 데 도움을 줍니다.",
      "커뮤니티 리더들",
      "회원님의 사람들을 찾고 관심사를 통해 친해지는 데에 도움이 되도록 디자인 되었어요.",
      "그룹 모임을 계획하거나, 근처에서 일어나는 있는 지역 이벤트를 발견해보세요.",
      "Plans",
      "BFF 둘러보기",
      "회원님께서 사랑과 친구를 찾는 것을 돕기 위해 필요한 모든 가이드와 영감이에요.",
      "내가 원하는 우정을 쌓는 데에 도움이 되는 조언과 이야기들이에요.",
      "우정 허브",
      "도쿄에서 토론토까지, Bumble 전 세계에서 발견한 사랑을 확인해보세요.",
      "사랑 이야기",
      "완벽한 데이트를 계획하세요—어디서, 언제, 누구와도 상관없이요.",
      "시즌 별 데이트 가이드",
      "이야기 살펴보기",
      "메인 페이지로 건너뛰기",
      "Bumble 로고",
      "내비게이션 메뉴 닫기",
      "내비게이션 메뉴 열기",
      "Whitney Wolfe Herd, Bumble 설립자이자 CEO",
      "Whitney Wolfe Herd는 Bumble 을 설립했습니다. 그녀의 목표는 여성들이 첫 인사를 건네고, 상호 존중을 기반으로 하는 가장 믿을 수 있는 연애 장소를 만드는 것이었습니다.{{__EOL__}}{{__EOL__}}CEO로서 그녀는 여전히 같은 믿음을 기반으로 하는 리더십을 보여주고 있습니다. 그 믿음은 온라인에서 사랑을 찾는 것이 의도적이고, 안전하고, 진솔한 과정이어야 한다는 것입니다. Bumble 은 단순한 연애에서 그치지 않습니다. 사람들이 분명한 목적과 진심 어린 관심과 함께 자신에게 중요한 가치를 찾는 것을 도와드리는 것이 중요합니다. 저희는 이를 위한 기술과 AI의 활용을 통해 사람 간의 연결을 대체하는 것이 아니라 사람 간 연결을 더 깊게 만들고자 합니다. 저희는 배운 모든 것들을 활용합니다. 좋은 점들, 불완전한 점들, 그리고 솔직함 모두를 적용해서 우리의 커뮤니티 모두가 Bumble 에서 환영받는다고 느끼도록 만들고자 합니다.",
      "Whitney Wolfe Herd",
      "웃고 있는 커플이  자동차 뒷 좌석에서 손을 잡고 키스를 하기 위해 다가가고 있으며 녹음이 우거진 바깥 풍경이 보입니다.",
      "우리는 사랑이—모든 형태의 사랑이—행복하고 건강한 삶의 기반이라고 믿습니다.",
      "안녕하세요. 우리는 사랑 회사입니다.",
      "대화를 시작하기 위한 문답이 있는 두 개의 프로필로 이루어진 Bumble 짝 화면입니다.",
      "결과요? 친절하고 건강한 연결을 만드는 회원 중심의 플랫폼이 되었습니다.",
      "{{date}} 년에, 우리는 연애 규칙을 다시 써 내렸습니다.",
      "우리의 미션은 사람들이 사랑에 더 가까워질 수 있도록 돕는 일입니다.",
      "우리의 사명",
      "우리는 연애의 규칙들을 뒤집고 여성에게 첫인사의 주도권을 주었습니다.",
      "Bumble 이 탄생했습니다",
      "{{bff}} 런칭을 통해 사람들이 내 사람을 찾는 데 도움이 되고 있습니다. 사랑은 플라토닉이기도 하니까요.",
      "데이팅을 넘어서서",
      "Serena Williams의 도움으로 슈퍼 볼에서 여성들이 첫 인사를 건네는 방식을 소개했습니다.",
      "슈퍼 볼 데뷔",
      "코로나19 팬데믹 중, 저희는 데이팅을 탐색하는 새로운 기능을 출시했습니다.",
      "데이팅이 온라인으로 이동했습니다",
      "가장 젊은 여성 리더의 주도 하에 대중에게 공개되었습니다.",
      "역사적인 순간",
      "온라인 상 원치않는 노출을 방지하는 기술과 함께, 저희는 여성들을 보호하는 정책들을 넓혔습니다.",
      "더 나은 안전",
      "우리는 여성 스포츠에 당연히 받아야 할 스포트라이트를 비추었습니다.",
      "WNBA x Bumble",
      "이제 저희는 모든 사람들이 진정한 사랑을 찾는 것이 가능한 미래를 만들고자 합니다.",
      "사랑으로 가는 길",
      "저희는 한 가지 대담한 행동으로부터 시작되었습니다. 오늘날 저희는 가장 신뢰할 수 있고 효과적으로 사랑을 찾을 수 있는 곳을 구축하고 있습니다.",
      "살펴보려면 스크롤하세요",
      "왼쪽으로 스크롤하기",
      "오른쪽으로 스크롤하기",
      "우리의 이야기",
      "채용 중인 직책들을 확인하세요",
      "저희가 사랑을 찾을 수 있는 가장 신뢰할 수 있는 장소를 구축하는 것을 도와주세요.",
      "함께 일하기",
      "친구와 연결되기 위한 사용자 프로필 보기 및 관심사 배지를 하이라이트한 BFF 앱 화면들",
      "새로운 도시에 이사왔거나 혹은 소셜 네트워크를 넓히고 싶거나, {{bff}}는 나와 같은 마음가짐을 가진 사람들을 만나는 가장 쉬운 방법입니다.",
      "내 사람들 찾기",
      "중앙에 거울 셀카를 찍는 여성을 포함하여 신분증 인증을 완료한 배지와 함께 보여지는 다양한 사람들의 Bumble 프로필 콜라주.",
      "여러분이 연애 초보자이든, 다시 시작하려는 것이든 상관없이, Bumble Date는 안전하고 의미 있게 사랑에 더 가까이 갈 수 있도록 설계되었습니다.",
      "내 사람 찾기",
      "웃고 있는 여성이 공원에서 스케이트보드를 들고 있어요",
      "야외활동",
      "도심 속 공원에서 조깅을 하면서 웃고 있는 남자",
      "러닝",
      "야외에서 작고 털이 뽀송한 강아지를 안고 있는 여성",
      "반려견 보호자",
      "Bumble 다운로드",
      "우리는 회원들이 자신감과 기쁨을 북돋는 의미 깊고 진정한 관계들을 찾는 데에 도움이 되고자 합니다.",
      "우리는 사람들을 사랑에 보다 가까워지게 하기 위해 존재합니다.",
      "머리에 선글라스를 걸치고 검은 머리칼을 포니테일로 묶은 여성이 검은 상의를 입고 바다를 배경으로 미소 짓고 있어요.",
      "패턴이 있는 셔츠를 입은 수염을 기른 남자가 카메라를 들고 나무와 빌딩들이 보이는 야외를 배경으로 서 있어요.",
      "무지개 색 줄무늬가 있는 자켓과 은색 헤드폰을 쓰고 있는 여성이 연두색 별 모양 목걸이를 하고 카메라를 쳐다보고 있어요.",
      "미소를 지으며 포옹하는 흑백 커플 초상",
      "{{name1}} 님과 {{name2}} 님, {{num}} 년 결혼",
      "더 알아보기",
      "더 많은 이야기를 읽어보세요",
      "“{{__EOL__}}저희 둘은 타고난 긍정적이고 즐거운 사람들이지만, 서로 함께일 때는 우리가 해내지 못할 일은 없다고 느껴요.",
      "테니스 코트에서 웃고 있는 두 사람; 한 명은 테니스 공을 자신의 눈처럼 들고 있어요",
      "오프라인에서 만나기",
      "Bumble IRL 이벤트는 타이핑을 멈추고 대화를 시작할 수 있는 기회입니다. 혼자서 혹은 친구와 함께 오셔서 새로운 연결을 만들고 떠나세요.",
      "오프라인에서 대화를 시작하세요",
      "Bumble에서 사진, 화상 채팅 및 전문 조언을 통해 연결을 즐기는 사람들",
      "가입하기",
      "Member Circle에 참여해 Bumble의 미래를 함께 만들어보세요. Member Circle 커뮤니티에서는 대화, 토론, 제품 테스트를 통해 회원인 여러분의 아이디어를 Bumble 팀과 직접 나눌 수 있습니다.{{__EOL__}}{{__EOL__}}새로운 기능과 다가올 캠페인을 누구보다 먼저 만나보고, 더 나은 Bumble 서비스를 만드는 데 함께하세요.",
      "아이디어 공유하기",
      "상대방을 좀 더 알아가고 싶으세요? Bumble 에서 영상 통화를 사용해보세요",
      "간단하게 회원님의 채팅에서 비디오 아이콘을 탭해서 영상 통화를 시작하세요. 어떠한 개인 연락처 정보도 공유하지 않아도 됩니다.",
      "Bumble 에서 영상 채팅은 어떻게 사용할 수 있나요?",
      "아니요. Bumble 에서의 모든 통화와 채팅은 회원님의 개인 정보를 안전하게 확실히 보호합니다. 회원님의 짝들은 회원님의 전화번호나 다른 어떠한 연락처 정보도 회원님께서 직접 말하기 전까지는 알아볼 수 없습니다.",
      "내 핸드폰 번호를 나와 짝이 된 사람들이 볼 수 있나요?",
      "물론이죠! 회원님께서 얼굴을 마주보고 짝과 대화하는 것이 아직 불편하다면, 음성 통화를 통해 연결될 수 있습니다. 간단하게 전화 아이콘을 선택하시면 됩니다.",
      "음성 통화를 사용할 수 있나요?",
      "우리 모두는 좋은 메시지를 받을 때 뜨는 알림을 사랑하죠. 하지만 이 대화가 실제로 만났을 때도 즐겁게 이어질지는 아무도 모릅니다. 이때 영상 통화와 음성 통화가 도움이 될 수 있어요.",
      "Bumble 에서의 화상 채팅",
      "<a href={{video_chat_url}}>영상 채팅과 음성 통화</a> 를 사용하면 서로를 좀 더 알아가는 데에 도움이 되며 앱을 떠나서 계속 연락을 주고받을지 결정할 수 있어요. 가장 좋은 점이요? Bumble을 통해 통화를 하면 전화 번호를 교환하지 않아도 계속 연락할 수 있어요. 회원님께서 개인 정보를 공유할 준비가 될 때까지 안전하게 지킬 수 있죠.",
      "영상 채팅으로 쿵짝이 잘 맞는지 확인하세요",
      "온라인에서 알아가는 상대방과 오프라인에서의 실제 상대방에는 차이가 있을 수 있죠, 이 차이를 먼저 파악하고 실제로 만나도 괜찮을지 결정해보세요.",
      "짝들을 더 잘 (그리고 더 빠르게) 알아보세요. 얼굴을 보며 하는 대화나 전화로 하는 대화는 사람들에 대해 많은 것을 알려주죠.",
      "회원님께서 결정하게 됩니다. 저희는 회원님의 연락처 정보를 비밀로 유지할 테니, 회원님께서 언제 연락처를 공유할지 선택할 수 있습니다.",
      "실제로 만날 준비가 되셨는지 확인해 보세요",
      "빠르게 분위기를 체크하세요",
      "개인정보를 알릴 필요 없이 연결되세요",
      "회원님께서 영상 채팅과 음성 통화를 사용해야 하는 이유",
      "대화를 시작할 준비가 되셨나요? Bumble 앱의 회원님의 채팅에서 음성 통화나 영상 통화를 바로 시작할 수 있습니다. 영상 통화를 시작하려면 오른쪽 상단 모서리에 있는 회색 비디오 카메라 아이콘을 탭하세요. 그 아이콘 옆에서 세 개의 점도 볼 수 있는데, 이를 클릭해서 음성 통화 옵션도 볼 수 있습니다.",
      "영상 채팅하는 방법",
      "Compliments를 사용할 준비가{{__EOL__}}되셨나요?",
      "Compliments를 보내시면, 받는 사람은 회원님의 프로필이 회원들 사이에서 나타날 때 이를 볼 수 있습니다.",
      "Bumble에서 누군가에게 Compliment를 보내면 어떻게 되나요?",
      "상대방이 보낸 Compliment가 회원님의 눈길을 끈다면, 바로 짝이 될 수 있어요. 회원님의 채팅에서 Compliment를 볼 수 있으며, <a href={{make_the_first_move_url}}>첫 인사를 건네는 방법</a> 의 일반적인 규칙이 적용됩니다",
      "Compliment에 어떻게 답장을 보낼 수 있나요?",
      "{{num}} 개의 [[Compliments:num]] 를 무료로 보낼 수 있습니다. 모두 소진되면, Bumble 앱에서 최대 30개까지의 패키지를 구매할 수 있습니다. 이 중 한 개는 해당 Compliment를 보내는 데 사용됩니다 (다른 프로필도 마음에 들 때를 위해서 나머지는 남겨두세요). 걱정마세요, 만료되는 기간은 없어요!",
      "Compliments를 몇 개까지 보낼 수 있나요?",
      "친절한 한 마디는 (아님 두 마디) 천 냥 빚을 갚는다고 하죠. Compliment를 보내고 싶지만 손가락이 키보드 위에서 갈 곳을 잃었다면, 다음 예시에서 영감을 얻으세요:",
      "더 많은 예시 보기",
      "\"[아티스트 이름], 이 사람을 좋아하는 사람들은 취향이 뛰어나죠.“",
      "“회원님의 미소는 전염성이 있는 것 같아요, 저도 미소짓게 되요!“",
      "“회원님의 자기소개 때문에 현웃이 터졌어요. 한 개그 하시네요.“",
      "Bumble 에서 더 나은 칭찬을 보내는 방법",
      "상대방의 하루를 특별하게 만들어볼까요? Compliments를 사용해 볼 준비가 되신 것 같네요.",
      "Bumble 에서의 Compliments",
      "Bumble 에서 Compliments를 사용하면 짝이 될지도 모르는 상대방에게 프로필이 마음에 든다고 알려줄 수 있어요 (상대방이 쑥쓰러워 할 수도 있지만요). {{service_level_lexeme_name}} 서비스의 일부로 Compliments가 포함됩니다. 이 기능은 짝이 되기도 전에 메시지를 보내고 받을 수 있는 방법이기도 해요.",
      "Compliments 기능{{__EOL__}}사용 방법",
      "Compliment를 받게 되면 회원님의 보낸 사람의 프로필에 나타나게 됩니다. 또한 회원님의 프로필 중 특정 부분을 좋아하는 사람이 있다는 알림도 받게 됩니다.",
      "회원님의 칭찬{{__EOL__}}확인하기",
      "다른 회원의 프로필 하단에 있는 노란색 하트 아이콘을 탭해서 Compliment를 보낼 수 있습니다. 탭을 한 프로필의 일부 부분이나 탭을 한 사진에 대해서 칭찬하게 되므로 어디를 탭할지 생각해보세요! 클릭하면 메시지를 입력할 수 있는 텍스트 상자가 열립니다. (최대 150자까지 쓸 수 있어요.)",
      "칭찬을 보내세요",
      "Bumble 을 다운{{__EOL__}}받고 지금{{__EOL__}}발견을{{__EOL__}}이용해보세요",
      "매일 오전 9시부터 새로운 사람들이 발견 페이지에 나타납니다. 이 사람들과 공통된 점들로 연결될 수 있습니다.",
      "발견 페이지는 언제 업데이트되나요?",
      "회원님의 발견 페이지에서는 잠재적인 짝들을 유사한 관심사, 동일한 연애 목표, 그리고 공통된 커뮤니티 3 개의 주 카테고리로 분류해서 볼 수 있습니다. 프로필 추천은 기존의 짝들을 기반으로 보여집니다.",
      "내 발견 페이지는 어떻게 구성되나요?",
      "하루에 한 번씩 업데이트 되는 회원님과 가장 잘 맞는 사람들을 하이라이트 해 드리는 맞춤형 페이지예요",
      "{{qr_code}} 발견에서 회원님의 분위기와{{__EOL__}}맞는 사람들을 찾으세요",
      "발견에서 보여드리는 사람들은 유사한 관심사, 연애 목표 및 공동체를 기반으로 저희가 선택한 회원님께서 좋아할 것 같은 사람들입니다.",
      "발견 이용해보기",
      "공통점들을 찾을 수 있는{{__EOL__}}새로운 방법이 필요하세요?",
      "발견 페이지는 매일 업데이트되며, 잘 어울릴 것 같은 사람들을 더 많이 보여줍니다—그래서 짝을 찾는 시간은 줄이고, 잘 맞는 사람들과 보다 깊이 연결되는 데에 더 많은 시간을 보낼 수 있습니다.",
      "매일 새로운 추천들",
      "발견 페이지에 추천된 사람들은 회원님께서 이전에 짝이 된 사람들에 기반을 두므로 회원님께서 좋아하는 것이나 원하는 것들이 같은 사람들을 볼 수 있습니다—비건 랍스터 롤이나 장기 연애, 뭐든지요.",
      "회원님을 위한{{__EOL__}}맞춤화",
      "Bumble 다운로드",
      "자주 하는 질문",
      "Bumble 을 비공개로 둘러볼 준비가 되셨나요?",
      "투명 회원 모드를 활성화하면, 회원님께서 찜한 프로필을 제외하고 다른 Bumble 회원에게는 회원님의 프로필이 나타나지 않습니다.",
      "투명 회원 모드는 어떻게 사용하나요?",
      "투명 회원 모드가 켜져 있지 않으면, Bumble 에서의 다른 회원들의 나이나 위치 같은 선호 사항에 회원님께서 해당되는 경우 회원님의 프로필이 보여집니다. 투명 회원 모드를 활성화하면, 회원님께서 찜한 회원들만 회원님의 프로필을 볼 수 있습니다.",
      "Bumble 의 투명 회원 모드에서 누가 나를 볼 수 있나요?",
      "투명 회원 모드를 사용하는 것과 <a href={{blocking_on_bumble_url}}>Bumble에서 누군가를 차단하는 것</a> 은 다릅니다. 이 기능을 사용하면, 회원님께서 누군가를 찜하면 (또는 과거에 메시지를 보낸 적이 있는 경우) 해당 회원은 회원님의 프로필을 볼 수 있습니다.",
      "투명 회원 모드가 누군가를 차단하는 것과 비슷한 건가요?",
      "Bumble 의 투명 회원 모드로 회원님의 프로필을 볼 수 있는 사람들을 직접 선택하세요.",
      "Bumble 에서의 투명 회원 모드",
      "데이트에서 한 걸음 물러나고 싶거나, Bumble 을 둘러보면서 다른 회원들이 회원님의 프로필을 볼 수 없도록 하고 싶다면 투명 회원 모드로 전환할 수 있습니다. 이 기능을 활성화하면 모든 사람들에게서 회원님의 프로필이 숨겨집니다 - 회원님께서 먼저 찜한 사람들에게만 회원님의 프로필이 나타납니다. 이 기능을 통해 누구에게 보여지고 무엇을 공유할지를 회원님께서 직접 통제할 수 있습니다.",
      "투명 회원 모드로{{__EOL__}}회원님의 프로필을 숨기세요",
      "회원님의 사진과 개인 정보를 볼 수 있는 회원을 직접 선택하세요.",
      "프로필에 개인적인 내용을 포함하고 싶으세요? 현재 짝이 된 사람들과 조용히 원하는 내용을 공유할 수 있어요.",
      "옛 연인, 직장 동료, 또는 회원님의 연애 대상이 아닌 사람들과 마주칠 걱정 없이 자유롭게 둘러보세요.",
      "회원님께서 완벽하게 통제하세요",
      "무엇을 공유할지 선택하세요",
      "어색한 마주침을 피하세요",
      "회원님께서 투명 회원 모드를 사랑하게 될 이유",
      "투명 회원 모드는 {{service_level_lexeme_name}} 및 {{service_level_lexeme_name_two}} 회원들이 사용할 수 있습니다. 가입을 완료한 후, 회원님의 프로필 탭으로 이동하여 상단 오른쪽 모서리에 있는 설정으로 이동한 다음, 투명 회원 모드를 활성화할 수 있습니다.",
      "{{service_level_lexeme_name}} 서비스로 업그레이드하세요",
      "Bumble 에서의 투명 회원 모드 사용 방법",
      "Bumble 을 지금{{__EOL__}}다운받고 오늘{{__EOL__}}바로 짝되기를{{__EOL__}}이용해보세요",
      "Bumble 앱에서 화면 하단에 있는 프로필 아이콘으로 향하세요. 해당 화면 오른쪽 상단에서 QR 코드를 찾으실 수 있어요. 탭해서 사용하세요.",
      "나의 QR 코드는 어디서 찾을 수 있나요?",
      "아니요! 모바일 데이터나 와이파이를 통해 인터넷에 연결되어 있어야 하며,가장 최근의 라이브 QR 코드를 사용하셔야 바로 짝되기를 사용하실 수 있어요.",
      "스크린샷을 찍어서 나의 QR 코드를 공유할 수 있나요?",
      "아니요! 한 사람이 코드를 스캔하면 자동으로 짝이 됩니다.",
      "두 사람 모두 QR 코드를 스캔해야하나요?",
      "바로 짝되기를 통해 자동으로 회원님과 회원님의 새로운 짝의 공통점을 볼 수 있어요—시작부터 바로 서로 잘 맞는지 알 수 있어요.",
      "공통점을{{__EOL__}}찾아보세요,{{__EOL__}}빠르게요",
      "Bumble IRL 이벤트에서 대화를 시작하셨나요? 앱에서 계속 이어가세요.",
      "이미 만난 귀여운 사람과 {{qr_code}} 바로 짝되기로 연결되세요",
      "바로 짝되기는 전화번호나 소셜 프로필을 교환하지 않고 귀여운 상대방에게 \"우리 계속 대화를 이어가요\"라고 말할 수 있는 쉬운 방법입니다. 상대방에게 회원님의 QR 코드를 스캔하도록 해서 Bumble 에서 짝이 될 수 있습니다.",
      "바로 짝되기를 시도해보세요",
      "Bumble IRL 이벤트에서{{__EOL__}}누군가를 만나셨다구요?",
      "소셜 프로필이나 전화번호를 교환하는 대신에, 바로 짝되기를 사용하면 앱에서 분위기를 확인할 수 있어요. 그렇게 하면, Bumble 의 안전한 기능들 덕에 서로를 천천히 알아갈 수 있어요.",
      "더 안전하게{{__EOL__}}연결되는{{__EOL__}}방법",
      "Bumble 의 IRL 이벤트에서 만난 후, 앱에서 대화를 이어가서 관계를 계속 발전시키고 공통의 관심사를 통해 연결되세요—완벽한 술안주에 대한 애정이든, 찾기 힘든 입맛 취향에 대해서 토론하는 대화든, 뭐든지요.",
      "대화를 계속 이어가세요",
      "휴식이 필요하신가요? 스누즈 모드를 사용해보세요",
      "네, 언제든지 설정이나 회원들 탭에서 스누즈를 끌 수 있어요.",
      "스누즈 모드를 조금 더 일찍 비활성화할 수 있나요?",
      "설정으로 이동한 다음 스누즈를 탭하고 오프라인 상태로 유지하고 싶은 기간을 선택하세요. 돌아올 준비가 되면 언제든지 돌아오세요.",
      "나의 프로필에서 스누즈 모드를 어떻게 사용하나요?",
      "아니요, 스누즈 모드에서는 모든 스와이프 및 채팅 활동이 일시 중단됩니다. 회원들 탭에 가면 스누즈 모드가 얼마나 오래 유지될지 알려주는 메시지와 함께 비활성화할 수 있는 옵션이 표시됩니다.",
      "스누즈 모드에서도 여전히 사람들의 프로필을 확인하고 채팅을 할 수 있나요?",
      "이미 메시지를 주고받은 사람들은 '오프라인' 상태(만약 설정하셨다면)를 볼 수 있습니다. 설정하지 않으셨다면, 상대방은 대화 목록에서 이전 메시지 내용을 평소처럼 보게 됩니다.",
      "스누즈 모드를 활성화하면 현재 짝들이 볼 수 있나요?",
      "여러분의 Bumble 활동은 온전히 여러분께서 스스로 제어할 수 있으며, 언제든지 한 걸음 물러서서 휴식을 가질 수 있습니다.",
      "회원님의 상태를 업데이트해서 기존에 연결된 사람들이 회원님께서 <a href={{ghosted_article_url}}>잠수</a> 를 탄다고 생각하지 않도록 알리고 연결을 유지할 수 있습니다. 또한 자동화되어 있으므로 따로 직접 메시지를 보내지 않아도 됩니다.",
      "적극적인 데이트 활동으로부터 잠시 휴식을 취해도 회원님의 연결이나 대화들이 사라지지 않습니다.",
      "내가 원하는 때에 데이트하고 필요하면 연결을 쉬어가세요",
      "회원님의 인연들에게 회원님의 상태를 알리세요",
      "활동은 잠시 쉬어가지만 연결은 끊지 않아요",
      "우리가 스누즈 모드를 사랑하는 이유",
      "Bumble 앱을 열고, 프로필 탭으로 이동한 후 오른쪽 상단 코너에 있는 설정 톱니바퀴를 탭하세요. 설정에서 스누즈를 탭하고 오프라인을 유지하고 싶은 기간을 선택하세요. 프로필을 24시간, 72시간, 일주일, 또는 회원님께서 직접 해제할 때까지 숨길 수 있습니다.{{__EOL__}}{{__EOL__}}스누즈 모드에서는 채팅이 이어지지 않은 짝들은 사라집니다. 상태를 설정해 두시면, 현재 대화를 주고 받고 있는 사람들은 회원님께서 오프라인임을 볼 수 있습니다.",
      "Bumble 에서 스누즈 모드는 이렇게 실행됩니다",
      "삶이 바쁠 때, 스누즈 모드가 도움이 될 수 있어요. Bumble 계정을 일시 정지하고, 스스로의 속도에 맞춰서 데이트를 하세요.",
      "Bumble 에서의 스누즈 모드",
      "스누즈 모드는 데이트로부터 휴식을 취하고 싶을 때 회원님의 계정을 일시 정지하는 쉬운 방법입니다. 기존의 연결들과는 여전히 채팅할 수 있으며, 회원님께서 다시 스와이프를 시작할 준비가 될 때까지 회원님의 프로필은 다른 사람들로부터 숨겨집니다. 회원님의 프로필 정보를 잃거나 기존 연락을 삭제하지 않고 스누즈 모드를 활성화할 수 있습니다.",
      "회원님의 Bumble 프로필을 잠시 스누즈하세요",
      "스누즈 모드를 사용 중이시라면, 상태 업데이트를 통해서 회원님께서 잠시 쉬어가는 중임을 기존의 인연들에게 알릴 수 있습니다. '여행 중', '일에 집중 중', '디지털 디톡스 중', 혹은 '저만을 위한 시간이 필요해요' 중에서 선택하세요. 여러분이 어떤 상태에 있던지, 저희가 지켜드릴게요.",
      "‘오프라인‘ 상태를 추가하세요",
      "스누즈 모드를 활성화하면 회원님의 Bumble (혹은 {{page_partner_name_bff}}) 계정이 일시 정지됩니다. 회원님의 짝들은 회원님께서 스누즈 모드라는 것을 알 수 없습니다. 처음 선택한 시간 기간보다 일찍 스누즈 모드에서 깨어나려면 설정으로 돌아가서 \"스누즈 모드 비활성화\"를 탭하세요.",
      "채팅을 일시 정지하세요",
      "Bumble 에서 SuperSwipe를 사용해보세요",
      "원하는 만큼이요! {{service_level_lexeme_name}} 구독 회원은 매주 {{num}} 개의 [[superswipe:num]] 를 받지만, 언제든지 충전할 수 있습니다. 무료 회원은 SuperSwipes 패키지를 구매할 수 있습니다.",
      "Bumble에서 SuperSwipes를 몇 개까지 보낼 수 있나요?",
      "누군가 회원님의 프로필에 SuperSwipe을 사용하면 즉시 알림을 받게 됩니다. 또한 해당하는 사람의 프로필 상단에 라벨이 표시되어 그 사람이 회원님을 좋아하는 것을 알 수 있습니다.",
      "누군가가 나에게 SuperSwipe를 보냈는지 어떻게 알 수 있나요?",
      "누군가에게 진지하게 관심이 가시나요? 어색함을 깨는 멋진 방법이 있어요. SuperSwipe를 보내서 그 사람에게 회원님이 관심이 있음을 알리고 즐거운 대화를 시작하세요, 빨리요.",
      "Bumble 에서의 SuperSwipe",
      "많은 사람들 사이에서 돋보이는 것은 언제나 쉽지 않지만, SuperSwipe를 사용하면 훌륭한 첫 인상을 남기는 데에 도움이 될 수 있습니다.{{__EOL__}}{{__EOL__}}SuperSwipe를 사용하시면, 회원님께서 좋아하는 사람에게 알림이 전송되며 해당 회원의 회원들 탭에서 가장 먼저 회원님의 프로필이 라벨과 함께 나타납니다. 해당 회원도 회원님을 찜하면 대화를 시작할 수 있습니다.",
      "SuperSwipe가{{__EOL__}}뭐예요?",
      "대담하게 돋보이세요",
      "더 많은 채팅을 시작하세요",
      "더 많은 연결을 만드세요",
      "SuperSwipe가{{__EOL__}}도와드릴게요…",
      "<a href={{bumble_boost_url}}>Bumble {{service_level_lexeme_name}}</a> 또는 Bumble {{service_level_lexeme_name_one}} 서비스를 구독 중인 경우, 주간 {{num}} 개의 [[superswipe:num]] 가 무료로 제공됩니다. 또한 모든 회원들은 프로필 탭에서 최대 {{num_two}} 개의 [[superswipe:num_two]] 패키지를 구매할 수 있습니다. {{service_level_lexeme_name_three}} 서비스를 구독하시는 경우, 주간 {{num_three}} 개의 [[superswipe:num_three]] 가 제공됩니다.{{__EOL__}}{{__EOL__}}SuperSwipe를 사용하는 방법은 간단합니다. 회원님께서 마음에 드는 사람을 발견하면, 상대방의 프로필 하단에 있는 노란색 별 아이콘을 탭하세요.",
      "SuperSwipe 사용 방법",
      "Bumble 의 트래블 모드로 여행 중에도 데이트를 찾으세요",
      "<a href={{bumble_premium_url}}>{{service_level_lexeme_name}} 회원</a> 들은 트래블 모드를 사용할 수 있습니다. 활성화하시면 회원님께서 선택한 도시의 새로운 사람들을 볼 수 있습니다.",
      "트래블 모드를 어떻게 사용하나요?",
      "거의 그렇습니다. 약간의 안전 관련 제한 사항이 있을 수 있으며 시간이 지남에 따라 변경될 수 있습니다. 그러나 트래블 모드는 거의 모든 곳에서 사용 가능합니다.",
      "트래블 모드는 어디서나 사용할 수 있나요?",
      "트래블 모드는 회원님께서 선택한 도시의 중심으로 회원님의 위치를 표시하여, 해당 지역에서 새로운 연결이 회원님을 찾을 수 있습니다. 사람들은 회원님의 프로필에서 회원님께서 트래블 모드를 사용 중이라는 문구를 볼 수 있으므로 회원님께서 여행 중이거나 여행을 올 계획이 있다는 것을 알 수 있습니다.",
      "여행을 위해 짐을 챙기는 중이거나 새로운 도시로 출장을 가시나요? Bumble 의 트래블 모드를 활성화해서 떠나는 가방에 데이트를 챙겨가세요.",
      "Bumble 에서의 트래블 모드",
      "트래블 모드는 여행 중에도 연결을 만드는 데 도움이 되는 최고의 도구입니다. 회원님의 위치를 전세계 어느 곳이든 설정하면 선택한 도시에 회원님의 프로필이 표시됩니다. 회원님의 모험이 어디로 향하든 그곳에서 데이트 경험에 뛰어들 수 있습니다.",
      "트래블 모드는 무엇인가요?",
      "그 지역에 사는 사람들이 그 도시를 가장 잘 알죠. 트래블 모드를 통해 여행을 특별하게 만들어 드릴 사람들과 연결해 드릴게요.",
      "여행하기 최대 7일 전에 회원님의 위치를 여행 도시로 설정해 주세요. 그러면 방문하기 전에 미리 짝들과 데이트 계획을 만들 수 있습니다.",
      "바다 여행보다 더 많은 것들을 상상해보세요 - 휴가 중일 수도 있고, 출장 중이시거나 또는 새로운 도시를 탐험하시는 와중에도, 어디에서든 로맨스를 찾아보세요.",
      "지역 최고의 데이트 장소를 찾으세요",
      "모험을 하세요",
      "오래 남을 연결들을 만드세요",
      "트래블 모드를 사랑할 이유",
      "트래블 모드는 <a href={{bumble_premium_url}}> {{service_level_lexeme_name}} 및 {{service_level_lexeme_name_two}} </a> 구독 회원들이 Bumble 에서 사용 가능합니다. 프로필의 오른쪽 상단에 있는 설정 톱니바퀴를 탭하고 스크롤해서 트래블 모드를 찾으세요. 새 위치를 선택해서 해당 지역에 사는 사람들을 볼 수 있어요. 상대방들은 회원님의 프로필에서 회원님께서 트래블 모드를 사용하고 있는 것을 볼 수 있습니다.",
      "트래블 모드는{{__EOL__}}어떻게 사용하나요?",
      "지금 사용해보세요",
      "이곳에서는 친절함이 곧 섹시함이며, 여러분 스스로의 가장 나 다운 모습이 완벽함이며, 여성이 먼저입니다. 항상요.",
      "첫인사를 건네는 곳의 시작",
      "긍정적이고 생산적인 삶의 핵심은 건강한 관계로부터 시작합니다. Bumble은 통제력을 지닌 상태에서 데이트 상대를 찾고 계시든, 친구를 찾고 계시든, 커리어 기반의 네트워크를 확장하고 싶으시든 상관없이 이러한 관계를 구축하시도록 도와드릴 수 있게 고안되었습니다.",
      "Bumble 이 중요한 이유",
      "저희는 관계의 모든 단계에 진실함, 친절함, 평등, 그리고 존경을 중심으로 행동하도록 격려하고 있습니다. 저희는 사랑을 찾고 있거나 단순히 재미있는 시간을 찾고 있는 모든 사람들을 환영하는 것 뿐만 아니라 모든 성향을 찬양하고자 합니다.",
      "Bumble 의 가치",
      "Bumble 에서는 여성들이 먼저 첫인사를 건네거나 짝들이 답장을 보낼 수 있는 Opening Move를 설정할 수 있습니다. 저희는 구식의 생각을 전환하여 인연의 첫 단계부터 평등이 유지될 수 있도록 격려하고 있습니다.",
      "Bumble 사용 방법",
      "저희를 소개합니다",
      "지금 다운로드하기",
      "앱은 더 멋져요.",
      "온라인 데이팅을 진심으로 즐겁게 만들기 위해 디자인된 기능들",
      "2024년 2월 12일",
      "관계에서 감정적 친밀감을 높이는 방법",
      "2024년 1월 25일",
      "데이팅 앱을 사용해본 적이 없으신 분에게 Bumble 앱을 사용하는 방법",
      "2024년 2월 5일",
      "사기 탐지기™",
      "널리 읽혀야 할 모든 데이팅 뉴스",
      "<b>스누즈 모드</b> 로 데이팅을 일시정지하세요. 다시 데이트할 준비가 되면, 언제든지 돌아오세요.",
      "잠깐 휴식하기",
      "<b>영상 통화</b> 와 <b>오디오 채팅</b> 을 사용해서 집콕하면서 상대방을 만나세요.",
      "다양하게 소통하세요",
      "더 보기",
      "<b>Opening Moves</b> 를 선택하면 내가 먼저 대화를 시작할 필요 없이 짝들이 인사를 건네도록 초대할 수 있어요.",
      "더 적은 노력으로 더 많이 데이트하세요",
      "<b>트래블 모드</b> 로 전 세계 어느 곳에서 짝이 될 수 있어요.",
      "가고 싶은 곳으로 떠나세요",
      "상대방의 프로필 분위기가 합격이라구요? <b>SuperSwipe</b> 로 마음을 전하세요.",
      "상대방의 주목을 끄세요",
      "<b>Compliments</b> 를 보내서 사람들 속에서 돋보이세요.",
      "상대방의 기분을 띄워주세요",
      "<b>투명 회원 모드</b> 를 사용해서 전 연인, 친척, 직장 상사로부터 프로필을 숨기세요.",
      "프라이버시를 지키세요",
      "원하는 방식으로{{__EOL__}}데이트하세요",
      "몇달 후에, 신부 들러리 중 한 명도 그곳에서 만나셨어요.",
      "Hannah님은 지금 남편을 Bumble에서 만나셨어요.",
      "이제 함께 작은 집을 짓고 있는 Carène님과 You-Liang님은 Bumble에서 만났어요. You-Liang님이 Carène님의 여행 사진에 끌렸다고 해요.",
      "Carène님과 You-Liang님",
      "Brian님과 Kaci님은 함께 외국에 발령을 받았어요 - 하지만 두 분은 Bumble에서 만나셨어요",
      "Brian님과 Kaci님",
      "다른 사람들에게 일어난 일은 여러분에게도 일어날 수 있어요",
      "다음 인연을 만드세요",
      "업데이트를 살펴보세요",
      "회원님은 최고로 대접받을 가치가 있어요. 그래서 스트레스 없이 데이트를 즐길 수 있는 멋진 방법들을 고안해봤어요.",
      "이상형의 기준을 타협할 필요가 없어요",
      "Bumble 소개",
      "저희는 여성의 경험을 우선시하여 데이팅 경험을 보다 낫게 만드는 단 하나 뿐인 앱입니다. 여성에게 나은 경험이 모두에게 나은 경험이기 때문입니다.",
      "Make the first move™",
      "정말로 데이트하고 싶은 사람을 찾고, 첫인사를 먼저 건네세요. 진실한 연결을 만들고, 공통 관심사를 나누세요. 그리고 가장 중요한 것은, 즐거운 시간을 보내세요.",
      "Bumble Date로 누군가를 만나세요",
      "커리어 혜택을 가진 친구들을 찾으세요. 다음 직장, 멘토, 혹은 완전히 새로운 커리어를 찾기 위해 다른 비지니스 전문가들과 연결되세요.",
      "Bumble Bizz로 커리어를 성장시키세요",
      "나와 닮은 사람을 만나세요. 아니면 반대인 사람을요. 집이든 여행 중이든 함께 새로운 활동을 할 수 있는 새로운 친구들을 만드세요.",
      "Bumble For Friends에서 새로운 친구들을 찾으세요",
      "데이팅 그 이상을 제공합니다",
      "Bumble은 여성이 첫 인사를 건네는 데이팅 앱입니다. 데이트와 의미있는 관계를 형성하고 네트워크를 만드는 방식을 변화시킨 앱입니다. 지금 다운로드하세요.",
      "{{social_network}} 에서의 Bumble",
      "더 알아보기",
      "App Store 또는 Google Play에서 Bumble 앱을 다운로드하신 뒤, 웹에서 사용하던 것과 동일한 계정으로 로그인해 주세요.{{__EOL__}}{{__EOL__}}아래의 QR 코드를 휴대폰 또는 태블릿으로 스캔하여 시작하세요.{{__EOL__}}{{__EOL__}}회원님의 매치와 대화가 앱에 그대로 있을 거예요. 💛",
      "앱 다운받기",
      "최고의 경험과 안전 기능을 계속 제공하기 위하여 앱 전용 서비스로 변경됩니다.",
      "Bumble은 이제 앱에서만 이용 가능합니다.",
      "소중한 인연을 놓치지 않도록 확인해보세요",
      "번호 공유 없이도 안전하게 통화해보세요.",
      "짝들의 진정성을 믿을 수 있어요.",
      "실시간 알림으로 새로운 메시지를 바로 확인해보세요.",
      "앱 내 음성 및 영상 통화로, 매치에서 실제 만남까지 안전하게 이어가보세요.",
      "간편한 앱 내 사진 및 신분증 인증으로, 인증된 회원과 안심하고 자신 있게 대화해보세요.",
      "왜 Bumble 앱을 사용해야 할까요?",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life",
      "Premium+",
      "죄송합니다. 현재 찾으시는 페이지를 발견할 수 없습니다.",
      "문의하기",
      "앗, 오류가 발생했어요",
      "(opens in new window)",
      "자주 하는 질문",
      "Cookie Policy",
      "Premium",
      "Bumble - The Blog",
      "인재 채용",
      "채팅",
      "시",
      "쿠키 관리",
      "Copyright © 2006 – present. Bumble. All rights reserved.",
      "자신 있는 데이트를 위한 보고서",
      "Apple 및 Apple 로고는 Apple의 등록 상표입니다.{{__EOL__}}Google Play(은)는 Google LLC의 상표입니다.",
      "다운로드하세요",
      "Facebook",
      "팔로우하세요",
      "도움말 센터",
      "Instagram",
      "언어",
      "LinkedIn",
      "Bumble는 Bumble Inc의 일부입니다.",
      "개인정보 취급방침",
      "Safety Centre",
      "사이트맵",
      "현대판 노예제 방지 성명",
      "이용약관",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "Compliments": {
            "plural": [
                  "칭찬보내기"
            ],
            "singular": [
                  "칭찬보내기"
            ]
      },
      "day": {
            "plural": [
                  "일"
            ],
            "singular": [
                  "일"
            ]
      },
      "hour": {
            "plural": [
                  "시간"
            ],
            "singular": [
                  "시간"
            ]
      },
      "minute": {
            "plural": [
                  "분"
            ],
            "singular": [
                  "분"
            ]
      },
      "month": {
            "plural": [
                  "개월"
            ],
            "singular": [
                  "개월"
            ]
      },
      "second": {
            "plural": [
                  "초"
            ],
            "singular": [
                  "초"
            ]
      },
      "superswipe": {
            "plural": [
                  "SuperSwipes"
            ],
            "singular": [
                  "SuperSwipe"
            ]
      },
      "year": {
            "plural": [
                  "년"
            ],
            "singular": [
                  "년"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
